import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#005591',
        secondary: '#00A0E1'
      }
    }
  }
}

export default new Vuetify(opts)
